var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{staticClass:"ampel",attrs:{"id":_vm.skala,"width":"400","height":"70"}},[_vm._v("Ihr Browser unterstützt das Element "),_c('code',[_vm._v("canvas")]),_vm._v(" nicht.")])}
var staticRenderFns = []

export { render, staticRenderFns }